// extracted by mini-css-extract-plugin
export default {"captionStyle":"SystemSettings_captionStyle__jb9cP"};